import { useContext, useEffect, useState } from 'react'
import PageContext from '../../global_state/context/PageContext'
import { BiShow, BiHide } from "react-icons/bi";
import DragAndDropInput from '../form/DragAndDropInput';

import FormSCSS from 'assets/scss/Form.module.scss'
import SCSS from 'assets/scss/CreateAccount.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'
import { PageType } from 'types/PageI';

import Title from 'components/Title';
import { CreateAccountService } from 'services/user_services/CreateAccountService';

import content from 'languages/CreateAccount.json'
import DateInput from 'components/form/DateInput';
import Loader from 'components/Loader';
import LoaderClasses from 'assets/scss/Loader.module.scss'


function CreateAccount() {

    const [registration_response, setRegistrationResponse] = useState<string | any>()   
    const {page, dispatchPage}  = useContext(PageContext)

    const [new_user, setNewUser] = useState({
        x_first_name: '',
        x_last_name: '',
        x_date_of_birth: '',
        x_phone_number: '',
        x_address: '',
        x_email: '',
        x_password: '',
        x_multisport_card: false,
        x_business_conditions: false,
    })

    const [new_user_errors, setNewUserErrors] = useState({
        x_first_name: false,
        x_last_name: false,
        x_date_of_birth: false,
        x_phone_number: false,
        x_address: false,
        x_email: false,
        x_password: false,
        x_multisport_card: false,
        x_business_conditions: false,
    })

    const [sent_request, setSentRequest] = useState(true)

    let required_fields = ['x_first_name', 'x_last_name', 'x_phone_number', 'x_email', 'x_password', 'x_business_conditions']
    
    const [x_password_visibility, setx_passwordVisibility] = useState(false)

    let language = page.settings.language
    const isx_passwordStrongEnought = (x_password: string): boolean => {
        if (x_password.length < 8) {
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: "weak_x_password"
                    }
                }
            }) 
            return false
        }
        return true
    }
    const handleSubmit = async (event) => {
        event.preventDefault()
        let error = handleRequiredItems()
        // console.log(error);

        if (error) {
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: "items_required"
                    }
                }
            })
            return 
        }

        
        
        if (!isx_passwordStrongEnought(new_user.x_password)){
            return 
        }

        setSentRequest(true)
        setRegistrationResponse(await CreateAccountService(new_user, language))
    }

    useEffect(() => {
        // console.log(registration_response);
        
        if (registration_response === PageType.verify_email) {
            dispatchPage({
                type: "render", 
                payload: {page: PageType.verify_email, props: {path: 'new'}}
            })
        }

        if ((typeof registration_response === 'string') && registration_response.includes("error")) {
         

            if (registration_response === 'possible_user_duplication_error'){
                // redirect out of the app 
                let link = new URL( window.location.href.split('?')[0] );
                // console.log(link);
                
                let wp_page = process.env["REACT_APP_WP_CONTACT_RECEPTION"] || 'contact-reception'
                // console.log(wp_page);
                link.pathname = wp_page

                // console.log(link);
                
                window.location.href = link.toString()
                // possible_user_duplication_error
                return 
            }

            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: registration_response
                    }
                }
            })

        }

        setRegistrationResponse(null)
        setSentRequest(false)


    }, [registration_response])

    const is_x_emailValid = () => {
        const x_email_re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!new_user.x_email.match(x_email_re)) {
            return false
        }        
        return true
    }

    const isErrorInDateInput = () => {
        
        if (new_user['x_date_of_birth'] != '' && new_user['x_date_of_birth'] != null) {
            // save only full date 
            // console.log("x_date_of_birth included".toUpperCase());
            // console.log(new_user['x_date_of_birth']);
            // console.log(typeof new_user['x_date_of_birth']);
            
            let parts = new_user['x_date_of_birth'].split('-')
            // console.log(parts);
            
            if (parts.length < 3) {
                return true
            }

            let has_empty = parts.some((value) => value == '')
            let all_empty = parts.every((value) => value == '')
            
            if (has_empty && !all_empty) {
                return true
            }

            if (parseInt(parts[2]) <= 0 || parseInt(parts[2]) > 31) {
                return true
            }
            if (parseInt(parts[1]) <= 0 || parseInt(parts[1]) > 12) {
                return true
            }
            if (parseInt(parts[0]) < 1900 || parseInt(parts[0]) > new Date().getUTCFullYear()) {
                return true
            }
        }
        return false
    }

    const handleRequiredItems = () => {

        let error_resonse = false
        let errors = {}

        let valid_x_email = is_x_emailValid()

        if (!valid_x_email) {
            errors['x_email'] = true
            error_resonse = true
        }

        if (isErrorInDateInput()) {
            error_resonse = true
            errors['x_date_of_birth'] = true
        }



        Object.keys(new_user).forEach(key => {
            if (required_fields.includes(key)){
                if ((new_user[key] == false) || (new_user[key] == '')) {
                    errors[key] = true
                    error_resonse = true
                }
            }
        });
        
        setNewUserErrors({...new_user_errors, ...errors})
        
        

        return error_resonse
    }   

    useEffect(() => {
        // console.log(new_user_errors);
        
    }, [new_user_errors])

    const renderRequiredField = (field_name: string) =>  {
        if (!(required_fields.includes(field_name))) {
            return ''
        }

        return ' *'
    }
    const renderErrorClass = (key) => {
        if (new_user_errors[key] == false) {
            return ""
        }

        return FormSCSS.input_error
    }

    const isButtonDisabled = ():boolean => {
        if (sent_request) {
            return true
        }
        return false
    }
    const renderButtonContent = () => {
        if (sent_request) {
            return <Loader class={[LoaderClasses.small, LoaderClasses.white].join(" ")}/>
        }
        
        return content[language].submit_button
    }

    return (
        <div className={[SCSS.create_account, FormSCSS.form_wrapper].join(" ")}>
            <Title back_arrow={true} title={content[language].welcome_title} page={PageType.entrance}></Title>

            <form className={FormSCSS.form} onSubmit={(event) => {handleSubmit(event)}}>
                            
                <div className={AppSCSS.subtitle}> 
                    <h4>{content[language].form_part_1} </h4>
                </div>

                <label className={FormSCSS.label} htmlFor="x_first_name">
                    <input className={[FormSCSS.input, renderErrorClass('x_first_name')].join(" ")} 
                        type="text" 
                        name='x_first_name'
                        id='x_first_name'
                        placeholder={content[language].x_first_name_placeholder + renderRequiredField('x_first_name')}
                        value={new_user.x_first_name}
                        onChange={(e) => {setNewUser({...new_user, x_first_name: e.target.value})}}
                        onFocus={(e) => {setNewUserErrors({...new_user_errors, x_first_name: false})}}
                    />
                </label>
                <label className={FormSCSS.label} htmlFor="x_last_name">
                    <input className={[FormSCSS.input, renderErrorClass('x_last_name')].join(" ")} 
                        type="text" 
                        name='x_last_name'
                        id='x_last_name'
                        placeholder={content[language].x_last_name_placeholder + renderRequiredField('x_last_name')}
                        value={new_user.x_last_name}
                        onChange={(e) => {setNewUser({...new_user, x_last_name: e.target.value})}}
                        onFocus={(e) => {setNewUserErrors({...new_user_errors, x_last_name: false})}}
                    />
                </label>

                <DateInput
                    className={renderErrorClass('x_date_of_birth')}
                    readOnly={false}
                    id={'x_date_of_birth'}
                    name={'x_date_of_birth'}
                    value={new_user.x_date_of_birth}
                    onChange={(key, value) => {                        
                        setNewUser({...new_user, [key]: value})
                    }}
                    onFocus={(key) => {setNewUserErrors({...new_user_errors, [key]: false})}}
                />

                <label className={FormSCSS.label} htmlFor="x_phone_number">
                    <input className={[FormSCSS.input, renderErrorClass('x_phone_number')].join(" ")} 
                        type="text" 
                        name='x_phone_number'
                        id='x_phone_number'
                        placeholder={content[language].x_phone_number_placeholder + renderRequiredField('x_phone_number')}
                        value={new_user.x_phone_number}
                        onChange={(e) => {setNewUser({...new_user, x_phone_number: e.target.value})}}
                        onFocus={(e) => {setNewUserErrors({...new_user_errors, x_phone_number: false})}}    
                        />
                </label>

                <label className={FormSCSS.label} htmlFor="x_address">
                    <input className={[FormSCSS.input, renderErrorClass('x_address')].join(" ")} 
                        type="text" 
                        name='x_address'
                        id='x_address'
                        placeholder={content[language].x_address_placeholder + renderRequiredField('x_address')}
                        value={new_user.x_address}
                        onChange={(e) => {setNewUser({...new_user, x_address: e.target.value})}}
                        onFocus={(e) => {setNewUserErrors({...new_user_errors, x_address: false})}}    
                    />
                </label>
            
                <div className={AppSCSS.subtitle}> 
                    <h4> {content[language].form_part_2} </h4>
                </div>
                
                <label className={FormSCSS.label} htmlFor="x_email">
                    <input className={[FormSCSS.input, renderErrorClass('x_email')].join(" ")} 
                        type="text" 
                        name='x_email'
                        id='x_email'
                        placeholder={content[language].x_email_placeholder + renderRequiredField('x_email')}
                        value={new_user.x_email}
                        onChange={(e) => {setNewUser({...new_user, x_email: e.target.value.toLowerCase()})}}
                        onFocus={(e) => {setNewUserErrors({...new_user_errors, x_email: false})}}     
                    />
                </label>

                <label className={FormSCSS.label} htmlFor="x_password">
                    <input className={[FormSCSS.input, renderErrorClass('x_password')].join(" ")} 
                        type={(x_password_visibility) ? "text" : "password"} 
                        name="x_password" 
                        id="x_password" 
                        placeholder={content[language].x_password_palceholder + renderRequiredField('x_password')}                         
                        value={new_user.x_password}
                        onChange={(e) => {setNewUser({...new_user, x_password: e.target.value})}}
                        onFocus={(e) => {setNewUserErrors({...new_user_errors, x_password: false})}} 
                    />
                    <div 
                        onClick={() => setx_passwordVisibility(!x_password_visibility)} 
                        className={FormSCSS.password_visibility}>
                        {(x_password_visibility) ? 
                            <BiShow/> : <BiHide/>}
                    </div>
                </label>
                
                <div className={SCSS.multisport_card}>
                    <span className={FormSCSS.multisport_label} >
                        {content[language].x_multisport_card}
                    </span>
                
                    <label className={FormSCSS.label} htmlFor="multisport_yes">
                        <input className={FormSCSS.input} 
                            type="checkbox" 
                            name="" 
                            id="multisport_yes" 
                            checked={(new_user.x_multisport_card) ? true : false}
                            onChange={(e) => {setNewUser({...new_user, x_multisport_card: !new_user.x_multisport_card})}}/>
                            <span>{content[language].x_multisport_card_yes}</span>
                    </label>
                    <label className={FormSCSS.label} htmlFor="multisport_no">
                        <input className={FormSCSS.input} 
                            type="checkbox" 
                            name="" 
                            id="multisport_no" 
                            checked={(new_user.x_multisport_card) ? false : true}
                            onChange={(e) => {setNewUser({...new_user, x_multisport_card: !new_user.x_multisport_card})}}/>
                            <span>{content[language].x_multisport_card_no}</span>
                    </label>
                </div>

                <label 
                    className={[SCSS.business_conditions, FormSCSS.label, renderErrorClass('x_business_conditions')].join(" ")}
                    htmlFor="x_business_conditions">
                    <input className={FormSCSS.input} 
                        type="checkbox" 
                        name="x_business_conditions" 
                        id="x_business_conditions" 
                        checked={(new_user.x_business_conditions) ? true : false}
                        onChange={(e) => {setNewUser({...new_user, x_business_conditions: !new_user.x_business_conditions})}}
                        onFocus={(e) => {setNewUserErrors({...new_user_errors, x_business_conditions: false})}}     
                    />
                        <span>{content[language].x_business_conditions + renderRequiredField('x_business_conditions')}</span>
                </label>
                <div className={SCSS.terms_and_conditions}>
                    <a target="_blank" href={content[language].terms_and_conditions_link}> {content[language].terms_and_conditions_text}</a>
                </div>
                
                <button 
                    className={[AppSCSS.button, AppSCSS.red].join(" ")}
                    disabled={isButtonDisabled()}
                    type="submit">
                        {renderButtonContent()}
                </button>
            </form>
        </div>
    )
}

export default CreateAccount